import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.ShareButtonRoot),
  () => import('./ShareButton'),
  (ShareButton) => {
    ComponentUtil.binder(Hooks.ShareButtonRoot, ShareButton);
  },
);
